module.exports = __webpack_public_path__ + "static/media/opensans-bold-webfont.4fc8e036.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-bold-webfont.woff
// module id = 1028
// module chunks = 0